import { forwardRef, memo } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import type { SwitchProps } from '@mui/material';
import { CustomSwitch, FormControlLabel } from './Switch.styles';

interface Props extends SwitchProps {
  label?: ReactNode;
  dataTestId?: string;
}

type TestableInputProps = InputHTMLAttributes<HTMLInputElement> & {
  'data-testid'?: string;
};

const getTestableInputProps = (
  inputProps: InputHTMLAttributes<HTMLInputElement> | undefined,
  dataTestId: string | undefined
): TestableInputProps => ({
  ...inputProps,
  'data-testid': dataTestId,
});

export const Switch = memo(
  forwardRef<HTMLButtonElement, Props>(({ label, dataTestId, inputProps, inputRef, slotProps, ...props }, ref) => {
    const mergedSlotProps = {
      ...slotProps,
      input: {
        ...(slotProps as any)?.input,
        ...getTestableInputProps(inputProps, dataTestId),
        ref: inputRef,
      },
    };

    return <FormControlLabel control={<CustomSwitch ref={ref} {...props} slotProps={mergedSlotProps} />} label={label} sx={{ ml: 1, gap: 1 }} />;
  })
);
